import React from 'react';
import { motion } from 'framer-motion';
interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
  title: string;
}
export function ProgressBar({
  currentStep,
  totalSteps,
  title
}: ProgressBarProps) {
  const progress = currentStep / totalSteps * 100;
  return <div className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100 px-4 py-3 md:px-8" data-id="element-602">
      <div className="max-w-4xl mx-auto" data-id="element-603">
        <div className="flex items-center justify-between mb-2" data-id="element-604">
          <div data-id="element-605">
            <span className="text-[10px] font-bold text-[#007AFF] uppercase tracking-widest" data-id="element-606">
              Stap {currentStep} van {totalSteps}
            </span>
            <h2 className="text-sm font-bold text-gray-900 mt-0.5" data-id="element-607">{title}</h2>
          </div>
          <span className="text-xs font-semibold text-gray-400 tabular-nums" data-id="element-608">
            {Math.round(progress)}%
          </span>
        </div>
        <div className="w-full h-1.5 bg-gray-100 rounded-full overflow-hidden" data-id="element-609">
          <motion.div className="h-full bg-[#007AFF] rounded-full" initial={{
          width: 0
        }} animate={{
          width: `${progress}%`
        }} transition={{
          duration: 0.5,
          ease: 'easeOut'
        }} data-id="element-610" />
        </div>
      </div>
    </div>;
}